import React, { useEffect } from "react";
import MenuBar from "../components/MenuBar";
import FooterSection from "../components/FooterSection";
import PageSEO from "../components/PageSEO";
import "../styles/ContactUs.css";

export default function ContactUsPage() {
  useEffect(() => {
    const scriptId = "hs-form-embed";
    if (document.getElementById(scriptId)) return;

    const script = document.createElement("script");
    script.id = scriptId;
    script.src = "https://js-na2.hsforms.net/forms/embed/245065734.js";
    script.defer = true;
    document.body.appendChild(script);
  }, []);

  useEffect(() => {
    const handleMessage = (event) => {
      let data = event.data;
      if (typeof data === "string") {
        if (data.includes("onFormSubmitted") || data.includes("onFormSubmit")) {
          window.location.href = "/thank-you.html";
          return;
        }
        try {
          data = JSON.parse(data);
        } catch (error) {
          data = null;
        }
      }
      if (!data || data.type !== "hsFormCallback") return;
      if (data.eventName === "onFormSubmitted" || data.eventName === "onFormSubmit") {
        window.location.href = "/thank-you.html";
      }
    };
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  useEffect(() => {
    const container = document.querySelector(".hs-form-frame");
    if (!container) return;

    let redirected = false;
    const redirectIfSubmitted = () => {
      if (redirected) return;
      const submitted =
        container.querySelector(".submitted-message") ||
        container.querySelector(".hs-form__submitted-message") ||
        container.querySelector(".hs-form .submitted-message");
      if (submitted) {
        redirected = true;
        window.location.href = "/thank-you.html";
      }
    };

    const observer = new MutationObserver(redirectIfSubmitted);
    observer.observe(container, { childList: true, subtree: true });

    const pollTimer = window.setInterval(redirectIfSubmitted, 500);

    return () => {
      observer.disconnect();
      window.clearInterval(pollTimer);
    };
  }, []);

  return (
    <div className="contact-us-page">
      <PageSEO
        title="Contact Sparkdenz | Book a Growth Consultation"
        description="Contact Sparkdenz to discuss SEO, paid media, CRO, and lifecycle marketing. Submit the form to receive a tailored growth plan within 48 hours."
        canonicalPath="/contact-us"
      />
      <MenuBar />
      <main>
        {/* Contact Hero */}
        <section className="contact-hero">
          <div className="section-inner">
            <p className="section-tag">Get in Touch</p>
            <h1>Let's Talk About Your Growth</h1>
            <p className="contact-hero-text">
              Ready to scale your lead pipeline? Tell us about your goals and we'll return 
              with a clear lead generation plan, channel mix, and next steps within 48 hours.
            </p>
          </div>
        </section>

        {/* Contact Content */}
        <section className="contact-content">
          <div className="section-inner">
            <div className="contact-wrapper">
              <div className="contact-info">
                <h2>How Can We Help?</h2>
                <p>
                  Fill out the form with your details and we'll get back to you as soon as possible.
                </p>

                <div className="contact-details">
                  <div className="contact-detail-item">
                    <div className="detail-icon">✉️</div>
                    <div className="detail-content">
                      <h3>Email</h3>
                      <p>sparkdenz@gmail.com</p>
                    </div>
                  </div>

                  <div className="contact-detail-item">
                    <div className="detail-icon">📍</div>
                    <div className="detail-content">
                      <h3>Location</h3>
                      <p>Remote Worldwide</p>
                    </div>
                  </div>

                  <div className="contact-detail-item">
                    <div className="detail-icon">⏱️</div>
                    <div className="detail-content">
                      <h3>Response Time</h3>
                      <p>Within 48 hours</p>
                    </div>
                  </div>
                </div>

                <div className="contact-benefits">
                  <h3>What You'll Get:</h3>
                  <ul>
                    <li>✓ Custom lead generation strategy</li>
                    <li>✓ Channel mix recommendations</li>
                    <li>✓ Growth roadmap</li>
                    <li>✓ Implementation timeline</li>
                  </ul>
                </div>
              </div>

              <div className="contact-form-container">
                <h2>Get Your Free Consultation</h2>
                <div
                  className="hs-form-frame"
                  data-region="na2"
                  data-form-id="bad2c75c-5e8d-4d7b-b9d4-9072b90e1556"
                  data-portal-id="245065734"
                ></div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="contact-faq">
          <div className="section-inner">
            <h2>Frequently Asked Questions</h2>
            <div className="faq-grid">
              <div className="faq-item">
                <h3>How quickly will you get back to me?</h3>
                <p>
                  We aim to respond to all inquiries within 48 hours. Most responses are sent 
                  within 24 hours during business days.
                </p>
              </div>
              <div className="faq-item">
                <h3>Do you offer free consultations?</h3>
                <p>
                  Yes! We provide a free initial consultation to understand your goals and 
                  create a tailored strategy for your business.
                </p>
              </div>
              <div className="faq-item">
                <h3>What industries do you work with?</h3>
                <p>
                  We work with B2B and B2C companies across various industries. Whether you're 
                  in tech, e-commerce, or services, we can help.
                </p>
              </div>
              <div className="faq-item">
                <h3>How do you measure success?</h3>
                <p>
                  We track KPIs like lead quality, conversion rates, ROI, and overall revenue 
                  impact. You'll get detailed monthly reports.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <FooterSection />
    </div>
  );
}
